export const ingredientBrandConstant = {
    ingredientType: 'ingredient',
    brandType: 'brand'
}
